<div class="layout-content">
  <sub-header>
    <ces-breadcrumb
      [menuItems]="logsBreadcrumbs"
      variation="design"
    ></ces-breadcrumb>
  </sub-header>

  <ces-card
    style="height: calc(100vh - 160px); overflow-y: hidden"
    class="card-job-list"
  >
    <ces-card-header>
      <div class="header-grid-container">
        <div class="textbx">
          <ces-textbox
            inputType="text"
            iconPosition="left"
            placeholder="Search logs here..."
            icon="icon-search"
            [clearText]="false"
            (onChange)="onSearchChange($event)"
          ></ces-textbox>
        </div>
      </div>
      <div class="ces-card-header-filters">
        <div class="advanceDateFilter">
          <advance-datepicker
            defaultDuration="Last 30 Days"
            (onDateSelect)="onDateSelect($event)"
          >
          </advance-datepicker>
        </div>
      </div>
    </ces-card-header>
    <ces-card-body>
      <ag-grid-angular
        #agAppListInstance
        id="agAppListInstance"
        class="ag-theme-alpine ces-table tableh100 w-100"
        [columnDefs]="appColDef"
        [defaultColDef]="defaultColDef"
        [animateRows]="false"
        (gridReady)="onGridReady($event)"
        [rowHeight]="36"
        [headerHeight]="38"
        [rowStyle]="{
          'max-height': '32px'
        }"
        (firstDataRendered)="gridAutoColumnFit($event)"
        (gridSizeChanged)="gridAutoColumnFit($event)"
        [overlayNoRowsTemplate]="noRowsTemplate"
        [rowModelType]="rowModelType"
        [cacheBlockSize]="cacheBlockSize"
        [enableRangeSelection]="true"
        [copyHeadersToClipboard]="true"
        [processCellForClipboard]="tableUtility.processCellForClipboard"
        [processHeaderForClipboard]="tableUtility.processHeaderForClipboard"
        [getContextMenuItems]="tableUtility.getContextMenuItems"
      >
      </ag-grid-angular>
    </ces-card-body>
    <div #container></div>
  </ces-card>
</div>
